<template>

    <div>
        <loading type="banner" v-if="isLoading"></loading>

        <div class="dd-l-grid dd-l-grid--list-light-content" v-if="results.length">
            <div class="dd-m-helper--full-row"></div>

            <div v-if="title" class="dd-m-extra--section-header">
                <h2 class="dd-m-extra--section-header__title">{{title}}</h2>
                <span class="dd-m-helper--detail-row"></span>
            </div>

            <div class="dd-l-grid--list-light-content__list">
                <card-light-content v-for="(item, index) in results" :item="item" :key="index"></card-light-content>
            </div>

            <div class="dd-l-grid--list-light-content__bottom" v-if="hasMore">
                <vue-ladda button-class="dd-m-button dd-m-button--auto dd-m-button--light"
                           v-on:click.prevent="loadMore()"
                           :loading="loadingMore">
                    {{getTranslateString('View More')}}
                </vue-ladda>
            </div>
        </div>
    </div>

</template>
<script>
    import Q from 'q';
    import ProductService from '../providers/api/product-service';
    import Loading from "./loading";
    import CardLightContent from "./cards/card-light-content";

    const productService = new ProductService();

    export default {
        name: 'list-light-content',
        components: {CardLightContent, Loading},
        props: ['title', 'perPage', 'productId'],
        data: () => {
            return {
                results: [],
                page: 1,
                hasMore: true,
                loadingMore: false,
                isLoading: false
            }
        },
        mounted() {
            if (this.productId) {
                this.getProductReviews();
            }

            this.subscribe();
        },
        methods: {
            subscribe() {
                PubSub.subscribe('updateReviewList', (msg, param) => this.update(param))
            },
            update(param) {
                this.results.push(param);
            },
            getProductReviews() {
                const d = Q.defer();

                this.isLoading = true;

                productService.doGetReviewsByProductId(this.productId, {page: this.page, perPage: this.perPage})

                    .then((res) => {
                        res.data.data.map((item) => this.results.push(item));
                        this.hasMore = res.data.pagination.links.next;
                        this.isLoading = false;
                        d.resolve();
                    })
                    .catch(() => {
                        this.isLoading = false;
                        d.resolve();
                    });

                return d.promise;
            },
            loadMore() {
                this.loadingMore = true;
                this.page++;
                this.getProductReviews()
                    .then(() => this.loadingMore = false);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/list-light-content.vue